import styled from 'styled-components'

export type FieldHintTone = 'muted' | 'warning' | 'danger'

// Подпись под полем ввода (подсказка / предупреждение / ошибка) — для полей без встроенного helperText
export const FieldHint = styled.span<{ $tone?: FieldHintTone }>`
  display: block;
  font-size: ${({ theme }) => theme.text.sm};
  line-height: 1.3;
  text-align: start;
  color: ${({ theme, $tone = 'muted' }) =>
    $tone === 'danger' ? theme.colors.danger : $tone === 'warning' ? theme.colors.warning : theme.colors.ink3};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.sm};
  }
`

export default FieldHint
